import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	heading: {
		id: 'navigation-apps-sidebar-nav4-sidebars-settings-global-products.product-discovery-section.heading',
		defaultMessage: 'Jira Product Discovery',
		description: 'Navigation group heading for JPD settings items',
	},
	accessItem: {
		id: 'navigation-apps-sidebar-nav4-sidebars-settings-global-products.product-discovery-section.access-item',
		defaultMessage: 'Access',
		description: 'Navigation item which links to a JPD user access configuration settings page',
	},
	globalFieldsItem: {
		id: 'navigation-apps-sidebar-nav4-sidebars-settings-global-products.product-discovery-section.global-fields-item',
		defaultMessage: 'Global fields',
		description: 'Navigation item which links to a JPD global fields page',
	},
	globalViewsItem: {
		id: 'navigation-apps-sidebar-nav4-sidebars-settings-global-products.product-discovery-section.global-views-item',
		defaultMessage: 'Global views',
		description: 'Navigation item which links to the JPD global views page',
	},
	viewBlueprintsItem: {
		id: 'navigation-apps-sidebar-nav4-sidebars-settings-global-products.product-discovery-section.view-blueprints-item',
		defaultMessage: 'Pre-built views',
		description: 'Navigation item which links to a JPD view blueprints setting page',
	},
	viewBlueprintsItemLozenge: {
		id: 'navigation-apps-sidebar-nav4-sidebars-settings-global-products.product-discovery-section.new-lozenge',
		defaultMessage: 'New',
		description: 'Lozenge for the new Pre-built views feature',
	},
	datesItem: {
		id: 'spa-apps-sidebar-global-settings-products.menu.product-discovery.dates-item',
		defaultMessage: 'Dates',
		description: 'Navigation item which links to a JPD dates settings page',
	},
	betaFeaturesItem: {
		id: 'navigation-apps-sidebar-nav4-sidebars-settings-global-products.product-discovery-section.beta-features-item',
		defaultMessage: 'Beta features',
		description: 'Navigation item which links to a JPD beta features settings page',
	},
	// TODO: remove when cleaning up `jpd_itr-beta-removal-release` FG
	betaFeaturesItemLozenge: {
		id: 'navigation-apps-sidebar-nav4-sidebars-settings-global-products.product-discovery-section.beta-features-item-lozenge',
		defaultMessage: '1 New',
		description: 'Text for the lozenge on the beta features item',
	},
});
